import { useEffect, useState } from "react";
import "./Hero.scss";
import ButtonSecondary from "../../components/shared/ButtonSecondary";
import HeroCrystal from "../../assets/images/hero-crystal.png";
import RisingEmbers from "../../components/RisingEmbers";

export default function Hero() {
	const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		const checkDevice = () => {
			setIsDesktop(
				!("ontouchstart" in window) &&
					!navigator.maxTouchPoints &&
					!navigator.msMaxTouchPoints
			);
		};

		checkDevice();
	}, []);

	useEffect(() => {
		if (isDesktop) {
			const handleMouseMove = (event) => {
				const windowWidth = window.innerWidth;
				const windowHeight = window.innerHeight;
				const relativeX = (event.clientX / windowWidth - 0.5) * 2;
				const relativeY = (event.clientY / windowHeight - 0.5) * 2;
				setMousePosition({ x: relativeX, y: relativeY });
			};

			window.addEventListener("mousemove", handleMouseMove);
			return () =>
				window.removeEventListener("mousemove", handleMouseMove);
		}
	}, [isDesktop]);

	const getShadowStyle = () => {
		const maxOffset = 10;
		const shadowX = -mousePosition.x * maxOffset;
		const shadowY = -mousePosition.y * maxOffset;
		return {
			"--shadow-x": `${shadowX}px`,
			"--shadow-y": `${shadowY}px`,
		};
	};

	return (
		<>
			<div className="hero">
				<div className="hero-content-wrapper content-wrapper-lg">
					<div className="hero-content">
						<span
							className="hero-title title-1"
							style={getShadowStyle()}
						>
							UNLOCK
						</span>
						<span
							className="hero-title title-2"
							style={getShadowStyle()}
						>
							Market
						</span>
						<span
							className="hero-title title-3"
							style={getShadowStyle()}
						>
							Insights
						</span>
						<span
							className="hero-title title-4"
							style={getShadowStyle()}
						>
							With
						</span>
						<span
							className="hero-title title-5"
							style={getShadowStyle()}
						>
							AURAI
						</span>
						<span className="hero-desc desc-1">
							Your Intelligent
						</span>
						<span className="hero-desc desc-2">Digital Oracle</span>
						<div className="hero-bg">
							<div className="embers-wrapper">
								<RisingEmbers
									className="embers"
									width={637}
									height={525}
									emberInterval={300}
								/>
							</div>
							<img
								src={HeroCrystal}
								alt="hero-crystal"
								width={882}
								height={588}
							/>
						</div>
						<div className="hero-cta">
							<ButtonSecondary
								className="about-btn pulse-effect"
								href="https://aur-ai.gitbook.io/aurai"
							>
								About AurAI
							</ButtonSecondary>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
